import { aiAgentInvalidations } from "@circle-react/lib/queries/aiAgents";
import { communityInboxChatInvalidations } from "@circle-react/lib/queries/communityInboxChats";

import { useCommunityInboxSync } from "@/react/components/Modals/MessagingModalCompass/hooks/useCommunityInboxSync";

import { useAvatarConversationPanelStore } from "./useAvatarConversationPanelStore";

// The panel body unmounts while closed, so the member channel is subscribed
// here instead: the floating button must follow chat activity either way.
export const AvatarChatActivitySync = () => {
  const activeChatId = useAvatarConversationPanelStore(s => s.activeChatId);

  useCommunityInboxSync({
    currentChatId: activeChatId ?? undefined,
    onChatActivity: () => {
      void communityInboxChatInvalidations.avatarChats();
      void aiAgentInvalidations.memberAvatars();
    },
  });

  return null;
};
